import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {InvoiceVisualisingComponent} from './invoice-visualising.component';


const routes: Routes = [
  {
    path: '',
    component: InvoiceVisualisingComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InvoiceVisualisingRoutingModule { }
